import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "./localStorage.service";
import { AlertsService, PinnedMsgAction } from './alerts.service';
import { UserNotificationType, hub } from "./external/hub";
import { Subject, filter, interval, repeat, takeUntil, takeWhile, timeInterval } from "rxjs";
import { AsyncService } from "./async.service";
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { TVHelper } from "./external/hub/helper";
import { ActionCallback, EmptyCallback } from "./external/api";
import { LanguageType } from "./external/config/misc";

@Injectable()
export class TranslationService {
	lang: LanguageType;
	private initToken: Subject<void>;
	private coreInited = false;
	langChanged: EmptyCallback;
	constructor(private translateService: TranslateService,
		private localStorage: LocalStorageService,
		private asyncSrv: AsyncService,
		private metaService: Meta) {

		const search = location.pathname;
		if (search && search.indexOf('/ua') != -1) {
			this.lang = LanguageType.ua;
			this.saveLang();
		} else if (search && search.indexOf('/ru') != -1) {
			this.lang = LanguageType.ru;
			this.saveLang();
		} else if (search && search.indexOf('/en') != -1) {
			this.lang = LanguageType.en;
			this.saveLang();
		} else {
			const s = this.localStorage.getData('lang', true);
			if (s)
				this.lang = +s as LanguageType;
		}
		
		
		if (this.lang != null && (this.lang < LanguageType.en || this.lang > LanguageType.ru))
			this.lang = null;

		if (this.lang == null && navigator.language) {
			const lang = navigator.language.toLowerCase();
			if (lang.indexOf('ua') != -1)
				this.lang = LanguageType.ua;
			else if (lang.indexOf('ru') != -1)
				this.lang = LanguageType.ru;
		}
		if (this.lang == null)
			this.lang = LanguageType.en;
		this.initToken = this.asyncSrv.createCancelationToken();
		this.setBrosersLanguage();
		this.translateService.use(LanguageType[this.lang]).subscribe(x => {
			this.asyncSrv.dispose(this.initToken);
		});
	}

	public async waitForInit() {
		await this.initToken.toPromise().then(x => {
			if (!this.coreInited) {
				TVHelper.expiredMsg = this.translate('User.' + TVHelper.expiredMsg);
				TVHelper.yearMsg = this.translate('User.' + TVHelper.yearMsg);
				TVHelper.dayMsg = this.translate('User.' + TVHelper.dayMsg);
				TVHelper.monthMsg = this.translate('User.' + TVHelper.monthMsg);
				this.coreInited = true;
			}
		});
	}

	public translate(message: string): string {
		if (!message)
			return '';
		let res = this.translateService.instant(message);
		return res ?? message;
	}
	//public translate = (message: string): string => {
	//	if (!message)
	//		return '';

	//	let res = this.translateService.instant(message);
	//	return res ? res : message;
	//}
	public translateEnum = (message: string): string => {
		if (!message)
			return '';
		const m = 'Enum.' + message;
		let res = this.translateService.instant(m);
		if (res == m)
			return message;
		return res ?? message;
	}
	public saveLang() {
		this.localStorage.saveData('lang', this.lang.toString(), true);
	}

	public applyLang = (lang: LanguageType, instant: boolean = true) => {
		if (this.lang == lang)
			return;
		this.lang = lang;
		this.saveLang();
		if (!instant)
			return;
		this.setBrosersLanguage();
		this.translateService.use(LanguageType[lang]).subscribe(() => {
			if (this.langChanged)
				this.langChanged();
		});
	}

	public setBrosersLanguage = () => {
		this.metaService.updateTag({ httpEquiv: 'content-language', content: LanguageType[this.lang] });
	}

	public getNotify(type: UserNotificationType): string {
		return this.translateService.instant("Notify." + UserNotificationType[type]);
	}
}
